import { IconAccountL } from 'icons/components/IconAccountL'
import { IconCardL } from 'icons/components/IconCardL'
import { IconChatChatS } from 'icons/components/IconChatChatS'
import { IconEmailL } from 'icons/components/IconEmailL'
import { IconEnvioL } from 'icons/components/IconEnvioL'
import { IconInfoL } from 'icons/components/IconInfoL'
import { IconMango } from 'icons/components/IconMango'
import { IconPhone } from 'icons/components/IconPhone'
import { IconProductL } from 'icons/components/IconProductL'
import { IconRefund } from 'icons/components/IconRefund'
import { IconStoreL } from 'icons/components/IconStoreL'
import type { IconProps } from 'icons/types/Icon.types'

export const categoryIcons: Record<
	string,
	(props: IconProps) => React.ReactNode
> = {
	chat: IconChatChatS,
	info: IconInfoL,
	email: IconEmailL,
	product: IconProductL,
	returns: IconRefund,
	phone: IconPhone,
	card: IconCardL,
	shipping: IconEnvioL,
	account: IconAccountL,
	mango: IconMango,
	store: IconStoreL,
}
